export default (article) => {

    return `
    
        <div class="exitline">
            <a href="${site === "tidslinje" ? `/tidslinje` : `javascript:window.history.back()`}" class="exitline__backbutton ${site === "tidslinje" ? `timeline` : `history`}"><span class="material-icons-outlined">arrow_back</span>${site === "tidslinje" ? `Til tidslinje` : `Søkeresultat`}</a>
            ${site == "tidslinje" ? `
            <div>
                <span class="d-lg-flex spin circle active exitline__year"><span class="counterspin_text highlight__year">${article.year}</span></span>
            </div>
            ` : ``}
        </div>
        
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-7">
                    <div class="article__header text-center">
                        <h1 class="article__header__title">${article.title}</h1>
                        ${article.intro ? `
                            <p class="article__header__intro">${article.intro}</p>
                        ` : ``}
                    </div>
                    ${article.mainImage ? `
                    <div class="article__mainimage__outercontainer">
                        <div class="article__mainimage__innercontainer article__imagecontainer">
                            <img src="${article.mainImage.src}" alt="${article.mainImage.desc}" data-id="${article.mainImage.dataid}" class="image__unresolved article__mainimage" />
                            ${article.mainImage.desc ? `<p class="article__mainimage__desc article__imagedesc">${article.mainImage.desc}</p>` : ``}
                        </div>
                    </div>
                    ` : ``}
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-lg-7 col-xl-6 col-xxl-5 ">
                    <div class="article__content">
                    
                        ${article.contentParsed}
                    
                    </div>
                </div>
            </div>
        </div>
    
        <div class="exitline">
            <a href="${site === "tidslinje" ? `/tidslinje` : `javascript:window.history.back()`}" class="exitline__backbutton ${site === "tidslinje" ? `timeline` : `history`}"><span class="material-icons-outlined">arrow_back</span>${site === "tidslinje" ? `Til tidslinje` : `Søkeresultat`}</a>
            ${site == "tidslinje" ? `
            <div>
                <span class="d-lg-flex spin circle active exitline__year"><span class="counterspin_text highlight__year">${article.year}</span></span>
            </div>
            ` : ``}
        </div>
    `;

}

export const otherHtml = (article) => {
    return `
        <div class="exitline">
            <a href="javascript:window.history.back()" class="exitline__backbutton other"><span class="material-icons-outlined">arrow_back</span>Tilbake</a>
        </div>
        
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-7 col-xl-6 col-xxl-5 ">
                    <div class="article__header text-start">
                        <h1 class="article__header__title">${article.title}</h1>
                        ${article.intro ? `
                            <p class="article__header__intro">${article.intro}</p>
                        ` : ``}
                    </div>
                    ${article.mainImage ? `
                    <div class="article__mainimage__outercontainer">
                        <div class="article__mainimage__innercontainer article__imagecontainer">
                            <img src="${article.mainImage.src}" alt="${article.mainImage.desc}" data-id="${article.mainImage.dataid}" class="image__unresolved article__mainimage" />
                            ${article.mainImage.desc ? `<p class="article__mainimage__desc article__imagedesc">${article.mainImage.desc}</p>` : ``}
                        </div>
                    </div>
                    ` : ``}
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 col-lg-7 col-xl-6 col-xxl-5 ">
                    <div class="article__content">
                        ${article.contentParsed}
                    </div>
                </div>
            </div>
        </div>
    `;
}